export default __webpack_public_path__ + "static/media/INEX 16.fe74d96c.svg";